import router from '@/router/index';
import {
  // WelcomeNavigation,
  VitalsNavigation,
  VitalsGroup,
  ResumeFsm
} from '@/store/modules/fsm/messages';

export default ({tree,parent,api}) => {
  if(!tree)
  {
    let {addState,PseudoStateKind} = api;
    let here = parent.active;
    addState('init',here,PseudoStateKind.ShallowHistory);
  }
  else
  {
    let { messageIs } = api;
    let here = parent.active;

    here.init
      .to(here.vitalsGroup);
    here.vitalsGroup
      .to()
      .when(messageIs(ResumeFsm))
      .effect(
        ({context}, {vitals})=> {
          context.commit('login/watch/setAllWatches',vitals,{root:true});
          // console.log(context.rootState.login)
          let group = null
          if (context.rootState.login.vitalsGroup)
            group = context.rootState.login.vitalsGroup.grouping
          else
            group = 'all'
          if (group) {
            router.push({
              name:VitalsGroup, 
              params: {
                grouping: group
              }
            })
          } else {
            router.push({name: VitalsNavigation})
          }

        }
      );
  }
};
